module.exports = __webpack_public_path__ + "static/media/golden_ticket_2.playngo.a051e744.jpeg";